const SESSION_ACCOUNT_KEY = 'nettles_auth_account';
const AUTH_COOKIE_NAME = 'nettles_auth';

function readAuthCookie() {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.cookie
    .split(';')
    .some((part) => part.trim().startsWith(`${AUTH_COOKIE_NAME}=`));
}

export function markAuthenticated(homeAccountId) {
  if (!homeAccountId) {
    return;
  }

  try {
    sessionStorage.setItem(SESSION_ACCOUNT_KEY, homeAccountId);
  } catch {
    // noop
  }

  try {
    document.cookie = `${AUTH_COOKIE_NAME}=1; path=/; SameSite=Lax`;
  } catch {
    // noop
  }
}

export function wasAuthenticated() {
  try {
    if (sessionStorage.getItem(SESSION_ACCOUNT_KEY)) {
      return true;
    }
  } catch {
    // noop
  }

  return readAuthCookie();
}

export function getStoredAccountId() {
  try {
    return sessionStorage.getItem(SESSION_ACCOUNT_KEY);
  } catch {
    return null;
  }
}

export function clearAuthenticatedMarker() {
  try {
    sessionStorage.removeItem(SESSION_ACCOUNT_KEY);
  } catch {
    // noop
  }

  try {
    document.cookie = `${AUTH_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
  } catch {
    // noop
  }
}

/**
 * Returns true when MSAL token entries still exist in localStorage.
 * Used to detect manual storage clears while a session marker remains.
 */
export function hasMsalTokenCacheInLocalStorage(clientId = process.env.REACT_APP_CLIENT_ID) {
  if (typeof window === 'undefined') {
    return false;
  }

  const normalizedClientId = clientId?.toLowerCase();

  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (!key) {
      continue;
    }

    const normalizedKey = key.toLowerCase();
    if (!normalizedKey.includes('idtoken')) {
      continue;
    }

    if (normalizedClientId && !normalizedKey.includes(normalizedClientId)) {
      continue;
    }

    return true;
  }

  return false;
}

export function shouldPromptLoginAfterSessionLoss({
  forceRelogin = false,
  hadAppSession = wasAuthenticated(),
  msalCachePresent = hasMsalTokenCacheInLocalStorage(),
  hasAccounts = false,
} = {}) {
  if (forceRelogin) {
    return true;
  }

  if (hadAppSession && !hasAccounts) {
    return true;
  }

  if (hadAppSession && !msalCachePresent) {
    return true;
  }

  return false;
}
